import "./style.css";
import * as THREE from "three";
import gsap from "gsap";
import typefaceFont from "three/examples/fonts/HelveticaNeue_Medium.json";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import * as Dat from "dat.gui";
import { BoxBufferGeometry, TorusGeometry } from "three";

/**
 * Debug
 */

const gui = new Dat.GUI();

const canvas = document.querySelector(".webgl");

////////////////////////////////////////////////////////////////////////////
// END OF DEBUG
////////////////////////////////////////////////////////////////////////////

/**
 * creating scene
 */
const scene = new THREE.Scene();

////////////////////////////////////////////////////////////////////////////
// END OF SCENE
////////////////////////////////////////////////////////////////////////////

/**
 * Geometry
 */
// const geometry = new THREE.BoxBufferGeometry(1, 1, 1);
// const material = new THREE.MeshBasicMaterial({
//   color: "white",
// });

////////////////////////////////////////////////////////////////////////////
// END OF GEOMETRY
////////////////////////////////////////////////////////////////////////////

/**
 * Mesh
 */

// const mesh = new THREE.Mesh(geometry, material);
// scene.add(mesh);

////////////////////////////////////////////////////////////////////////////
// END OF MESH
////////////////////////////////////////////////////////////////////////////

// todo axis helper
// const axisHelper = new THREE.AxisHelper();
// scene.add(axisHelper);

/**
 * Font LOAD
 */

const textureLoader = new THREE.TextureLoader();

const doorColorTexture = textureLoader.load("/textures/door/color.jpg");
const doorAlphATexture = textureLoader.load("/textures/door/alpha.jpg");
const doorAmbinentOcclusionTexture = textureLoader.load(
  "/textures/door/ambinentOcculsion.jpg"
);
const doorHeightTexture = textureLoader.load("/textures/door/height.jpg");
const doorNormalTexture = textureLoader.load("/textures/door/normal.jpg");
const doorMetalnessTexture = textureLoader.load("/textures/door/metalness.jpg");
const doorRoughnessTexture = textureLoader.load("/textures/door/roughness.jpg");

const matCapTexture = textureLoader.load("/textures/matcaps/7.png");
const gradientsTexture = textureLoader.load("/textures/gradients/5.jpg");

const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
scene.add(ambientLight);
const pointLight = new THREE.PointLight(0xffffff, 0.5);
pointLight.position.x = 4;
pointLight.position.y = 2;
pointLight.position.z = 2;
scene.add(pointLight);

const fontLoader = new FontLoader();
fontLoader.load(
  "./helvetica.json",
  // callback
  (font) => {
    const textGeometry = new TextGeometry(
      "    Xettri Aleen\nconsole.log(true)",
      {
        font: font,
        size: 0.5,
        height: 0.1,
        curveSegments: 50,
        bevelEnabled: true,
        bevelThickness: 0.05,
        bevelSize: 0.02,
        bevelOffset: 0,
        bevelSegments: 4,
      }
    );

    // lets center Text
    // old way to center position
    // textGeometry.computeBoundingBox();
    // console.log(textGeometry.boundingBox);
    // textGeometry.translate(
    //   -(textGeometry.boundingBox.max.x - 0.02) * 0.5,
    //   -(textGeometry.boundingBox.max.y - 0.02) * 0.5,
    //   -(textGeometry.boundingBox.max.z - 0.01) * 0.5
    // );

    // latest way to center to position
    textGeometry.center();

    const textMaterial = new THREE.MeshToonMaterial({
      // wireframe: true,
      color:'#E9A6A6',
  
    });

 
textMaterial.gradientMap= gradientsTexture;
gradientsTexture.minFilter= THREE.NearestFilter;
gradientsTexture.magFilter= THREE.NearestFilter;
    const text = new THREE.Mesh(textGeometry, textMaterial);
    scene.add(text);

    const donutGeometry = new TorusGeometry(0.2, 0.1, 20, 45);
    const donutMaterial = new THREE.MeshToonMaterial({
      // wireframe: true,
      color:'#864879'
    });
    const boxGeometry = new BoxBufferGeometry(0.1, 0.1, 0.1);
    const boxMaterial = new THREE.MeshToonMaterial({
      // wireframe: true,
      color:'#3F3351'
    });
    for (let i = 0; i < 200; i++) {
      const boxMesh = new THREE.Mesh(boxGeometry, boxMaterial);
      const donutMesh = new THREE.Mesh(donutGeometry, donutMaterial);
      donutMesh.position.x = (Math.random() - 0.5) * 10;
      donutMesh.position.y = (Math.random() - 0.5) * 10;
      donutMesh.position.z = (Math.random() - 0.5) * 10;
      boxMesh.position.x = (Math.random() - 0.5) * 15;
      boxMesh.position.y = (Math.random() - 0.5) * 15;
      boxMesh.position.z = (Math.random() - 0.5) * 15;

      donutMesh.rotation.x = Math.random() * Math.PI;
      donutMesh.rotation.y = Math.random() * Math.PI;

      const scale = Math.random();
      donutMesh.scale.x = scale;
      donutMesh.scale.y = scale;
      donutMesh.scale.z = scale;

      scene.add(donutMesh, boxMesh);
      const clock = new THREE.Clock();
      const animate = () => {
        const elapsedTime = clock.getElapsedTime();
        donutMesh.rotation.x = Math.sin(elapsedTime);

        window.requestAnimationFrame(animate);
      };
      animate();
    }
  }
);

////////////////////////////////////////////////////////////////////////////
// END OF FONT
////////////////////////////////////////////////////////////////////////////

// todo size
const size = {
  width: window.innerWidth,
  height: window.innerHeight,
};

////////////////////////////////////////////////////////////////////////////
// END OF SIZE
////////////////////////////////////////////////////////////////////////////

/**
 * camera
 */

const camera = new THREE.PerspectiveCamera(75, size.width / size.height);
camera.position.z = 3.2;
camera.position.x = -6.8;
camera.position.y = -1.6;
camera.lookAt(FontLoader)

gui.add(camera.position, "x", -10, 10);
gui.add(camera.position, "y", -10, 10);
gui.add(camera.position, "z", -10, 10);

// mouse movement
let mouse = {
  x: 0,
  y: 0,
  z: 0,
};
window.addEventListener("mousemove", (event) => {
  mouse.x = event.clientX / size.width - 0.5;
  mouse.y = event.clientY / size.height - 0.5;
  console.log(mouse.x, mouse.y);
});

window.addEventListener("resize", () => {
  // resize canvas

  size.width = window.innerWidth;
  size.height = window.innerHeight;
  //   update camera
  camera.aspect = size.width / size.height;
  camera.updateProjectionMatrix();
  renderer.setSize(size.width, size.height);
});

////////////////////////////////////////////////////////////////////////////
// END OF CAMERA
////////////////////////////////////////////////////////////////////////////

/**
 * Renderer
 */

const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  alpha: true,
});
scene.add(camera);

////////////////////////////////////////////////////////////////////////////
// END OF RENDERER
////////////////////////////////////////////////////////////////////////////

// controls
// const controls = new OrbitControls(camera, canvas);
// controls.enableDamping = true;
renderer.setSize(size.width, size.height);
renderer.render(scene, camera);

////////////////////////////////////////////////////////////////////////////
// END OF CONTROLS
////////////////////////////////////////////////////////////////////////////

/**
 * Animation
 */

const clock = new THREE.Clock();

const animate = () => {
  const elapsedTime = clock.getElapsedTime();
  camera.position.x = (mouse.x * elapsedTime )/20 ;
  camera.position.y =( mouse.y * elapsedTime)/20;
 

  camera.rotation.x=Math.sin(elapsedTime) / 10;
  camera.rotation.y=Math.cos(elapsedTime) /10;
  // controls.update();
  // mesh.rotation.x= elapsedTime;
  renderer.render(scene, camera);
  window.requestAnimationFrame(animate);
};

animate();

////////////////////////////////////////////////////////////////////////////
// END OF ANIMATION
////////////////////////////////////////////////////////////////////////////
